import { FormatMoney } from 'format-money-js';

const formatter = new FormatMoney({
    decimals: 2,
    separator: '.',
    symbol: '€ ',
    decimalPoint: ',',
});

export const parseDecimal = (value) => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }

    let normalized = String(value).trim();

    if (normalized.includes(',') && normalized.includes('.')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else {
        normalized = normalized.replace(',', '.');
    }

    const parsed = Number.parseFloat(normalized);

    return Number.isFinite(parsed) ? parsed : 0;
};

export const formatMoney = (value, decimals = 2) => {
    return formatter.from(parseDecimal(value), { decimals });
};

export const calculateTotal = (price, quantity, total = null) => {
    return total !== null && total !== undefined
        ? parseDecimal(total)
        : parseDecimal(price) * parseDecimal(quantity);
};
